var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.gameType)?_c('div',{staticClass:"home"},[_c(_vm.activeComponent,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }